<template>
  <div class="department-line-menu">
    <MenuIcon
      :dropdownItems="visibleMenuItems"
      @onClick="handleMenuClick"
      :menuWidth="true"
      :isOpen="menuOpen"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MenuIcon from '@components/MenuIcon/MenuIcon.vue';

const props = defineProps({
  department: { type: Object, default: () => ({}) },
  status: { type: String, default: 'Draft' },
  menuOpen: { type: Boolean, default: false }
});

const emit = defineEmits(['action']);

const visibleMenuItems = computed(() => {
  const status = props.status?.toLowerCase();

  const rawItems = [
    // Group 1: Items shown in Draft
    status === 'draft' && { name: 'Activate', value: 'activate', icon: 'icons/dropdown/activate.svg' },
    status === 'draft' && { name: 'Delete', value: 'delete', icon: 'icons/dropdown/trash.svg', destructive: true, negative: true },

    // Group 2: Items shown in Active
    status === 'active' && { name: 'Retire', value: 'retire', icon: 'icons/dropdown/activate.svg' },

    // Group 3: Items shown in Retired
    status === 'retired' && { name: 'Reactivate', value: 'reactivate', icon: 'icons/dropdown/activate.svg' },
    
    // Group 4: Rename hidden when archived
    status !== 'archived' && { name: 'Rename', value: 'rename', icon: 'icons/dropdown/rename.svg' },

    // Group 5: Items shown in Retired (Archive is separate from Reactivate/Rename)
    status === 'retired' && { name: 'Archive', value: 'archive', icon: 'icons/dropdown/archive-new.svg' },

    // Group 6: Items shown in Archived
    status === 'archived' && { name: 'Unarchive', value: 'unarchive', icon: 'icons/dropdown/activate.svg' },
  ].filter(Boolean);

  // Note: Copy link is omitted as per behavior table requirement: "Do not show at this time"
  
  return rawItems;
});

function handleMenuClick(item) {
  if (item && item.value) {
    emit('action', { type: item.value, department: props.department });
  }
}
</script>

<style scoped>
.department-line-menu {
  width: 20%;
  text-align: end;
}
</style>
